// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"32607dd1","48":"f1318c31","419":"beb70c13","563":"98745ffc","787":"96f489b3"}[chunkId] + ".chunk.js";
};